// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"c04075d89fa8671659cd","993":"366ad155aed0f31a5aaa"}[chunkId] + ".js");